import { useEffect, useState } from "react";

export default function useIsHydrationComplete() {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return (typeof window !== "undefined" && window.__isHydrated) || hasMounted;
}
